import * as model from './model';
import * as view from './view';

export default function (){
    const data = view.initDate();

    if (data.slidCarousels) {
        data.slidCarousels.forEach((sect) => {
            model.initSlideOwlCarousel(sect.children[0].id)
        })
    }
}